<template>
  <v-container fluid grid-list-xl>
    <span class="headline" v-if="address.id">{{ $t('editModel', { model: $tc('models.address', 1) }) }}</span>
    <span class="headline" v-else>{{ $t('createModel', { model: $tc('models.address', 1) }) }}</span>

    <v-form @submit.prevent="submit">
      <v-card class="mt-4">
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.aka"
                  name="aka"
                  :label="$t('attrs.aka')"
                  v-validate="'required'"
                  :error-messages="errors.collect('aka')"
                  data-vv-name="aka"
                  :data-vv-as="$t('attrs.aka')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.name"
                  name="name"
                  :label="$t('attrs.name')"
                  v-validate="'required'"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                  :data-vv-as="$t('attrs.name')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.company"
                  name="company"
                  :label="$t('attrs.company')"
                  v-validate="'required'"
                  :error-messages="errors.collect('company')"
                  data-vv-name="company"
                  :data-vv-as="$t('attrs.company')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.email"
                  name="email"
                  :label="$t('attrs.email')"
                  v-validate="'required'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  :data-vv-as="$t('attrs.email')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.phone"
                  name="phone"
                  :label="$t('attrs.phone')"
                  v-validate="'required'"
                  :error-messages="errors.collect('phone')"
                  data-vv-name="phone"
                  :data-vv-as="$t('attrs.phone')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-select v-model="address.country_id"
                  :items="countries"
                  item-value="id"
                  item-text="name"
                  :label="$tc('models.country')"
                  @change="fetchStates"
                  :disabled="loading"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.postal_code"
                  name="postal_code"
                  :label="$t('attrs.postal_code')"
                  v-validate="'required'"
                  :error-messages="errors.collect('postal_code')"
                  data-vv-name="postal_code"
                  :data-vv-as="$t('attrs.postal_code')"
                  required
                  @change="fetchColonies"
                  :disabled="loading"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-select v-model="address.state"
                  :items="states"
                  item-value="name"
                  item-text="name"
                  :label="$tc('models.state')"
                  :disabled="!address.country_id || loading"
                  :error-messages="errors.collect('state')"
                  data-vv-name="state"
                  :data-vv-as="$t('attrs.state')"
                  required
                  v-if="states.length"
                ></v-select>

                <v-text-field v-model="address.state"
                  item-value="name"
                  item-text="name"
                  :label="$tc('models.state')"
                  :error-messages="errors.collect('state')"
                  data-vv-name="state"
                  :data-vv-as="$t('attrs.state')"
                  required
                  v-else
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.street"
                  name="street"
                  :label="$t('attrs.street')"
                  v-validate="'required'"
                  :error-messages="errors.collect('street')"
                  data-vv-name="street"
                  :data-vv-as="$t('attrs.street')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.number"
                  name="number"
                  :label="$t('attrs.number')"
                  v-validate="'required'"
                  :error-messages="errors.collect('number')"
                  data-vv-name="number"
                  :data-vv-as="$t('attrs.number')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-select v-model="address.neighborhood"
                  :items="colonies"
                  item-value="name"
                  item-text="name"
                  :label="$tc('attrs.neighborhood')"
                  :error-messages="errors.collect('neighborhood')"
                  data-vv-name="neighborhood"
                  :data-vv-as="$t('attrs.neighborhood')"
                  required
                  :disabled="loading"
                  v-if="isMexico"
                ></v-select>

                <v-text-field v-model="address.neighborhood"
                  item-value="name"
                  item-text="name"
                  :label="$tc('attrs.neighborhood')"
                  :error-messages="errors.collect('neighborhood')"
                  v-validate="'required'"
                  data-vv-name="neighborhood"
                  :data-vv-as="$t('attrs.neighborhood')"
                  required
                  v-else
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.city"
                  name="city"
                  :label="$t('attrs.city')"
                  v-validate="'required'"
                  :error-messages="errors.collect('city')"
                  data-vv-name="city"
                  :data-vv-as="$t('attrs.city')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="address.reference"
                  name="reference"
                  :label="`${$t('attrs.reference')} (${$t('optional')})`"
                  maxlength="35"
                  placeholder="No mayor a 35 caracteres"
                ></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import axios from 'axios'

import Country from '@/client/country'
import State from '@/client/state'
import Address from '@/client/address'

export default {
  name: 'AddressFormView',

  props: {},

  data () {
    return {
      loading: false,
      countries: [],
      states: [],
      colonies: [],
      address: {},
      codeAddress: '',
      subLocalities: []
    }
  },

  components: {
  },

  computed: {
    isMexico () {
      const country = this.countries.find(o => o.id === this.address.country_id)
      if (!country) { return false }

      return country.code === 'MX'
    },
  },

  methods: {
    async fetchStates () {
      this.states = []
      this.states = await State.all({
        where: { country_id: this.address.country_id },
        per_page: 2000
      })
    },

    async fetchColonies () {
      if (!this.isMexico) { return }

      this.loading = true
      try {
        const url = 'https://sat.api.hydraship.app/api/colonies'
        const res = await axios.get(url, { params: { postal_code: this.address.postal_code } })
        this.colonies = res.data.data
        if (!this.colonies.length) { return }

        this.address.city = this.colonies[0].city
        this.address.state = this.colonies[0].state
      } catch (e) {
        this.handleErr(e)
      }
      this.loading = false
    },

    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.address.user_id = this.$auth.currentUser.id
        this.address.visible = true
        await this.address.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    clearCityState () {
      this.address.city = ''
      this.address.state = ''
      this.address.neighborhood = ''
      this.subLocalities = []
    }
  },

  watch: {
    'address.reference' (val) {
      if (val.length > 35) {
        this.address.reference = val.slice(0, 35)
      }
    }
  },

  async mounted () {
    this.address = new Address()

    const id = this.$route.params.id
    if (id) {
      this.address = await Address.findOne(id)
    }

    // this.countries = await Country.all()
    this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
    if (this.address.postal_code) {
      this.fetchColonies()
    }
    this.fetchStates()
  }
}
</script>
